/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { propertyGeneralStateSchema } from "./propertyGeneralStateSchema.ts";
import { propertyTypeEnvironmentSchema } from "./propertyTypeEnvironmentSchema.ts";
import { z } from "zod";

export const propertyCharacteristicsSchema = z.object({
      "constructionYear": z.number().describe("Année de construction").optional(),
  "landArea": z.number().default(0).describe("Surface du terrain"),
  "habitableArea": z.number().default(0).describe("Surface habitable"),
  "rooms": z.number().default(0).describe("Nombre de pièces"),
  "bedrooms": z.number().default(0).describe("Nombre de chambres"),
  "bathrooms": z.number().default(0).describe("Nombre de salles de bain"),
  "toilets": z.number().default(0).describe("Nombre de toilettes"),
  "floors": z.number().default(0).describe("Nombre d'étages"),
  "generalState": z.lazy(() => propertyGeneralStateSchema).describe("Etat général du bien :\n- NEW : Neuf\n- GOOD : Bon\n- AVERAGE : Moyen\n- BAD : Mauvais\n").optional(),
  "balconyArea": z.number().describe("Surface du balcon").optional(),
  "terraceArea": z.number().describe("Surface de la terrasse").optional(),
  "livingRoomArea": z.number().default(0).describe("Surface du séjour"),
  "gardenArea": z.number().describe("Surface du jardin").optional(),
  "isFurnished": z.boolean().describe("Indique si le bien est meublé").optional(),
  "environment": z.lazy(() => propertyTypeEnvironmentSchema).describe("Type d'environnement :\n- URBAN : Urbain\n- RURAL : Rural\n").optional(),
  "necessaryWorks": z.boolean().describe("Indique si des travaux sont nécessaires").optional()
      })